import Keycloak from 'keycloak-js';

let authProvider: Keycloak | undefined = undefined;

export type TokensType = {
    idToken: string;
    refreshToken: string;
    token: string;
};

const initKeycloakProvider = (
    idpUrl: string,
    realm: string,
    clientIdExtern: string
): Keycloak => {
    const keycloak = new Keycloak(
        JSON.parse(
            localStorage.getItem('keycloak_provider') ??
                JSON.stringify({
                    url: idpUrl,
                    realm,
                    clientId: clientIdExtern
                    // possible values : clientIdIntern | clientIdExtern
                })
        )
    );
    return keycloak;
};

export const getAuthProvider = (
    idpUrl: string,
    realm: string,
    clientIdExtern: string
): Keycloak => {
    // eslint-disable-next-line no-undef
    if (typeof authProvider === 'undefined') {
        authProvider = initKeycloakProvider(idpUrl, realm, clientIdExtern);
    }
    return authProvider;
};

export const getDefaultAuthProvider = (): Keycloak | null => {
    // eslint-disable-next-line no-undef
    const provider = localStorage.getItem('provider');
    if (provider) {
        return new Keycloak(JSON.parse(provider));
    }
    return null;
};

export interface KeyCloakProvider {
    url: string;
    realm: string;
    clientId: string;
}
